// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../fonts/betty-webfont.woff2");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../fonts/betty-webfont.woff");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../fonts/betty.otf");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
exports.push([module.id, "@font-face{font-family:TattooInk;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ") format(\"woff2\");src:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ") format(\"woff\");src:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ") format(\"opentype\")}\n", ""]);
// Exports
module.exports = exports;
